import EmphasisMediasSection from '../../components/Site/EmphasisMediasSection';
import EmphasisMediasSectionLoading from '../../components/Site/EmphasisMediasSectionLoading';
import { SectionProps } from '../../components/Site/Section';
import LangEnum from '../../lang/LangEnum';
import { processImageCoverUrl } from '../../lib/MediasLib';
import { ShowroomViewMode } from '../../services/modules/brand-showroom/brand-showroom.types';
import { imageMimeTypes } from '../media/mimeType';
import useMediaListManager from '../media/useMediaListManager';
import { useTranslation } from '../translation/TranslationContext';
import { brandShowcaseRepository } from './brandShowcase.repository';

type BrandEmphasisProductsSectionProps = {
  sectionProps: Partial<SectionProps>;
  brandId: string;
  viewMode: ShowroomViewMode;
};
const BrandEmphasisProductsSection = ({
  sectionProps,
  brandId,
  viewMode,
}: BrandEmphasisProductsSectionProps) => {
  const emphasisMediaListManager = useMediaListManager({
    id: 'mediasShowcase',
    api: brandShowcaseRepository(brandId),
    autoSave: true,
  });
  const { translate } = useTranslation();

  if (sectionProps.readOnly && emphasisMediaListManager.medias.length === 0) {
    return null;
  }

  if (emphasisMediaListManager.loading) {
    return <EmphasisMediasSectionLoading />;
  }

  return (
    <EmphasisMediasSection
      mimeTypes={imageMimeTypes.join(',')}
      sectionProps={sectionProps}
      processFileCover={processImageCoverUrl}
      medias={emphasisMediaListManager.medias}
      mediaListManager={emphasisMediaListManager}
      addButtonLabel={translate(LangEnum.SHOWROOM_FEATURED_PRODUCTS_ADD_PHOTOS)}
      mobileAddButtonLabel={translate(LangEnum.SHOWROOM_FEATURED_PRODUCTS_ADD_PHOTOS_MOBILE)}
      viewMode={viewMode}
    />
  );
};

export default BrandEmphasisProductsSection;
